import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
  }

  editEnabled(event) {
    $(event.target).parent().addClass("d-none").next("div").removeClass("d-none")
    $(event.target).blur()
  }

  editDisabled(event) {
    $(event.target).parent().addClass("d-none").prev("div").removeClass("d-none")
    $(event.target).blur()
  }
}
